import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // Disable all console logs, warnings, and errors in production
  ['log', 'warn', 'error', 'info', 'debug'].forEach(method => {
    (console as any)[method] = () => {};
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    if (!environment.production) console.error(err);
  });
